import { ItemView } from '@glu/core';
import template from './defaultLabelView.hbs';

export default ItemView.extend({
  template
});
